import {
  Grid,
  Card,
  Alert,
  Snackbar,
  TextField,
  Typography,
  FormControl,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Container } from "@mui/system";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { useLogin } from "../../hooks/useLogin";
import { useAuthContext } from "../../hooks/useAuthContext";
import React from "react";
import "../../assets/css/login.css";

import companyLogo from "../../assets/images/logo-new.png";
import loginBackgroundImage from "../../assets/images/login/login-bg-2.png";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { config, loginAPI, forgotPasswordAPI } from "../../config";
import { AlertMessage } from "../../components/AlertMessage";

function Login() {
  const navigate = useNavigate();
  const childRef = useRef();
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      if (user.role == "user") {
        navigate("/user/ticket/list");
      } else if (user.role === "agent" || user.role === "Admin") {
        navigate("/agent/dashboard");
      }
    }

    return () => true;
  }, []);

  const [data, setData] = useState({});

  const validationSchema = Yup.object().shape({
    txtPassword: Yup.string().required("Password is required"),
    txtEmail: Yup.string()
      .required("Email is required")
      .email("Please enter valid email format"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, reset, formState } = useForm(formOptions);

  const { errors } = formState;

  const [alertType, setAlertType] = useState("success");
  const [errMessage, setErrMessage] = useState("");
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [intOTP, setOTP] = useState("");

  const [txtResetPassword, setResetPassword] = useState("");
  const [txtResetConfirmPassword, setResetConfirmPassword] = useState("");

  const [open, setOpen] = useState(false);
  const [isLoadingSubmit, setLodingSubmit] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isVerifiedOTP, setIsVerifiedOTP] = useState(false);

  const [isSendOTP, setIsSendOTP] = useState(false);
  // const { login, isLoding, error } = useLogin();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { dispatch } = useAuthContext();

  // const navigate = useNavigate();
  function onSubmit(data) {
    setLodingSubmit(true);
    console.log(data);

    // const login = async () => {
    // setIsLoading(true);
    setError(null);
    // console.log(data1);
    var reqData = JSON.stringify({
      email: data.txtEmail,
      password: data.txtPassword,
    });

    // var config = {
    //   method: "post",
    //   url: "http://backend.imaginetventures.in/api/login",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   data: reqData,
    // };

    config.method = "post";
    config.url = loginAPI;
    config.data = data;

    // debugger;
    axios(config)
      .then(function (response) {
        // console.log(response.data.data[0].token);
        if (response.data.data.length != 0) {
          const jsonData = {
            email: response.data.data[0].email,
            token: response.data.data[0].token,
            name: response.data.data[0].username,
            role: response.data.data[0].role,
            department: response.data.data[0].department,
            id: response.data.data[0].id,
            departmenthead: response.data.data[0].departmenthead,
          };

          // meData — structured user metadata including token expiry (7 days)
          const meData = {
            id: response.data.data[0].id,
            name: response.data.data[0].username,
            email: response.data.data[0].email,
            role: response.data.data[0].role,
            department: response.data.data[0].department,
            departmenthead: response.data.data[0].departmenthead,
            token: response.data.data[0].token,
            tokenExpiry: Date.now() + 7 * 24 * 60 * 60 * 1000, // 7 days in ms
          };

          localStorage.setItem("user", JSON.stringify(jsonData));
          localStorage.setItem("meData", JSON.stringify(meData));
          dispatch({ type: "LOGIN", payload: jsonData });
          // navigate("/user/ticket/dashboard");
          if (
            response.data.data[0].role === "agent" ||
            response.data.data[0].role === "Admin"
          ) {
            window.location.href = "/agent/dashboard";
          } else {
            window.location.href = "/user/ticket/list";
          }
        } else {
          console.log(response.data.message);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setErrMessage("Invalid Username or Password");
      })
      .finally(() => {
        setLodingSubmit(false);
      });
    // };
    // debugger
    // login(data);

    //   axios.post("lnkExpertPoolContactForm", data).then((response) => {
    //     reset();
    //     setAlertType("success");
    //     setAlertMessage("We have received your queries, will get back to you soon. Thank you");
    //     setOpen(true);
    //     setLodingSubmit(false);
    //     setTimeout(function () {
    //       setOpen(false);
    //     }, 10000);
    //   });
  }

  const handleForgotPassword = () => {
    setIsForgotPassword(!isForgotPassword);
  };

  const handleSendOTP = () => {
    setErrMessage("");
    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(forgotPasswordEmail)
    ) {
      setErrMessage("Please enter valid email");
      return false;
    }

    var reqData = JSON.stringify({
      txtEmail: forgotPasswordEmail,
      intSpType: 2,
    });
    config.method = "post";
    config.url = forgotPasswordAPI;
    config.data = reqData;

    setLodingSubmit(true);

    // debugger;
    axios(config)
      .then(function (response) {
        console.log(response.data.data);
        if (response.data.message === "Invalid email") {
          setErrMessage(response.data.message);
        } else {
          setIsSendOTP(!isSendOTP);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setErrMessage("Invalid Username or Password");
      })
      .finally(() => {
        setLodingSubmit(false);
      });
  };

  const handleResetPassword = () => {
    setErrMessage("");
    if (txtResetPassword === "") {
      setErrMessage("Please enter password");
      return false;
    }
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/i.test(
        txtResetPassword
      )
    ) {
      setErrMessage(
        "Password Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      );
      return false;
    }

    if (txtResetPassword !== txtResetConfirmPassword) {
      setErrMessage("Passwords must match");
      return false;
    }

    var reqData = JSON.stringify({
      txtEmail: forgotPasswordEmail,
      txtPassword: txtResetPassword,
      intSpType: 4,
      txtOTP: intOTP,
    });
    config.method = "post";
    config.url = forgotPasswordAPI;
    config.data = reqData;

    setLodingSubmit(true);

    // debugger;
    axios(config)
      .then(function (response) {
        console.log(response.data);
        if (response.data.message === "Password Reset Successful") {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "Password Reset Successful",
              messageType: "success",
            })
          );
          setErrMessage("");
          setTimeout(function () {
            window.location.reload();
          }, 3000);
        } else {
          // setIsVerifiedOTP(!isVerifiedOTP);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setErrMessage("");
      })
      .finally(() => {
        setLodingSubmit(false);
      });
  };
  const handleVerifyOTP = () => {
    console.log(intOTP);
    var reqData = JSON.stringify({
      txtEmail: forgotPasswordEmail,
      intSpType: 3,
      txtOTP: intOTP,
    });
    config.method = "post";
    config.url = forgotPasswordAPI;
    config.data = reqData;

    setLodingSubmit(true);

    // debugger;
    axios(config)
      .then(function (response) {
        console.log(response.data);
        if (response.data.message === "Invalid OTP") {
          setErrMessage(response.data.message);
        } else {
          setIsVerifiedOTP(!isVerifiedOTP);
          setErrMessage("");
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setErrMessage("Invalid Username or Password");
      })
      .finally(() => {
        setLodingSubmit(false);
      });
  };

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isLoadingSubmit}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <AlertMessage ref={childRef} />
      <Grid container className="full-height">
        <Grid
          className="padding-10 login-background"
          item
          xs={12}
          lg={4}
          md={4}
          alignItems="center"
        >
          <Grid textAlign="center">
            <img
              src={companyLogo}
              alt="LogRamcides Ticketing System (RTS)"
              className="logo-image"
            />
            <Typography variant="h4" mb={1} className="color-white">
              Ramcides Ticketing System (RTS)
            </Typography>
          </Grid>
          <Grid>
            <img
              src={loginBackgroundImage}
              alt="Login Background"
              className="login-background-img"
            />
          </Grid>
        </Grid>
        <Grid
          className="login-center"
          item
          xs={12}
          lg={8}
          md={8}
          alignItems="center"
        >
          <Grid className="inner-login-box">
            <Container>
              {isVerifiedOTP ? (
                <>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Reset Password
                    </Typography>
                    <div className="empty-space-20"></div>
                  </Grid>
                  <Grid>
                    <TextField
                      name="txtPassword"
                      type="password"
                      label="Password"
                      fullWidth
                      value={txtResetPassword}
                      onChange={(e) => setResetPassword(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Grid>
                    <TextField
                      name="txtPassword"
                      type="password"
                      label="Confirm Password"
                      fullWidth
                      value={txtResetConfirmPassword}
                      onChange={(e) => setResetConfirmPassword(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtPassword?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          onClick={handleResetPassword}
                          disabled={formState.isSubmitting}
                        >
                          Submit
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  </FormControl>
                </>
              ) : isSendOTP ? (
                <>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Enter OTP
                    </Typography>
                    <div className="empty-space-20"></div>
                  </Grid>
                  <Grid>
                    <TextField
                      name="txtEmail"
                      type="text"
                      label="Enter OTP"
                      fullWidth
                      value={intOTP}
                      onChange={(e) => setOTP(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>

                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <div className="empty-space-20"></div>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          onClick={handleVerifyOTP}
                          disabled={formState.isSubmitting}
                        >
                          Verify OTP
                        </LoadingButton>
                      </Grid>
                      <Grid item xs={12} lg={6} md={6} textAlign="right">
                        <a
                          onClick={() => setIsSendOTP(!isSendOTP)}
                          className="pointer"
                        >
                          Change email
                        </a>
                      </Grid>
                    </Grid>
                  </FormControl>
                </>
              ) : isForgotPassword ? (
                <>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Forgot Password
                    </Typography>
                    <div className="empty-space-20"></div>
                  </Grid>
                  <Grid>
                    <TextField
                      name="txtEmail"
                      type="text"
                      label="Email"
                      fullWidth
                      value={forgotPasswordEmail}
                      onChange={(e) => setForgotPasswordEmail(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>

                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <div className="empty-space-20"></div>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          onClick={handleSendOTP}
                          disabled={formState.isSubmitting}
                        >
                          Send OTP
                        </LoadingButton>
                      </Grid>
                      <Grid item xs={12} lg={6} md={6} textAlign="right">
                        <a onClick={handleForgotPassword} className="pointer">
                          Cancel
                        </a>
                      </Grid>
                    </Grid>
                  </FormControl>
                </>
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Login
                    </Typography>
                    <div className="empty-space-20"></div>
                    {/* <Typography variant="body">
                      Use your AD credentials to gain access to this portal
                    </Typography> */}
                  </Grid>
                  <Grid>
                    <TextField
                      name="txtEmail"
                      type="text"
                      label="Email"
                      fullWidth
                      {...register("txtEmail")}
                      className={`form-control ${errors.txtEmail ? "is-invalid" : ""
                        }`}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Grid>
                    <TextField
                      name="txtPassword"
                      type="password"
                      label="Password"
                      fullWidth
                      {...register("txtPassword")}
                      className={`form-control ${errors.txtPassword ? "is-invalid" : ""
                        }`}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtPassword?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          type="submit"
                          disabled={formState.isSubmitting}
                        >
                          Login
                        </LoadingButton>
                      </Grid>
                      <Grid item xs={12} lg={6} md={6} textAlign="right">
                        <a onClick={handleForgotPassword} className="pointer">
                          Forgot Password?
                        </a>
                      </Grid>
                    </Grid>
                  </FormControl>
                </form>
              )}
            </Container>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Login;
